import { CameraType } from 'APP_ROOT/data/media';
import { SET_CAMERA } from './actions';

const initialState = {
    cameraType: CameraType.CAMERA_ROAD
};

export default function(state = initialState, action) {
    switch(action.type) {
        case SET_CAMERA:
            return {
                ...state,
                cameraType: action.payload
            };
        default:
            return state;
    }
};
